export const initialStateAuth = {
  user: null,
  token: null,
  refreshToken: null,
  isAdmin: null,
  isLogged: null,
  isCollab: null,
}
